import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserStore } from '../services/current-user-store';

/**
 * Route guard factory. Fails closed: if the current-user cache hasn't loaded yet,
 * kicks off a load and re-checks. Sends unauthorized users to the dashboard overview
 * rather than the login page — they are authenticated, just not entitled to this route.
 */
export const permissionGuard = (permissionKey: string): CanActivateFn => async () => {
  const store = inject(CurrentUserStore);
  const router = inject(Router);

  if (store.me() === null) {
    await store.load();
  }

  if (store.hasPermission(permissionKey)) return true;
  return router.createUrlTree(['/dashboard']);
};
